export const countJourneyStatuses = (fieldDevices, visibleDeviceIds = null) => {
  const counts = { active: 0, idle: 0, offline: 0 };
  const visible = visibleDeviceIds ? new Set(visibleDeviceIds) : null;

  (fieldDevices || []).forEach((device) => {
    const id = String(device.serial_number || device.device_id || "").trim();
    if (visible && !visible.has(id)) return;

    const status = String(device.journey_status || "offline").toLowerCase();
    if (Object.prototype.hasOwnProperty.call(counts, status)) {
      counts[status] += 1;
    }
  });

  return counts;
};

export const buildJourneyStatusByDeviceId = (fieldDevices) => {
  const statusByDeviceId = {};
  (fieldDevices || []).forEach((device) => {
    const id = String(device.serial_number || device.device_id || "").trim();
    if (!id) return;
    statusByDeviceId[id] = String(device.journey_status || "offline").toLowerCase();
  });
  return statusByDeviceId;
};
